import { CrossTeamCounterpart } from "@interfaces/company.interface";
import useDialogStore from "@store/useDialogStore";
import { BaseDialog } from "@ui/Dialogs";
import { formatCounterpartNames } from "../utils";

interface IConfirmRemoveDomainModalProps {
  domain?: string;
  /** When set, the domain is the last shared match keeping a cross-team connection alive. */
  counterparts?: CrossTeamCounterpart[];
  onCancel?: () => void;
  onConfirm: () => void;
}

export function ConfirmRemoveDomainModal({
  domain,
  counterparts,
  onCancel,
  onConfirm,
}: IConfirmRemoveDomainModalProps) {
  const { closeDialog } = useDialogStore();
  const isCrossTeam = Boolean(counterparts && counterparts.length > 0);
  const domainNode = domain ? <span className="font-medium">{domain}</span> : "this domain";

  return (
    <BaseDialog
      title={isCrossTeam ? "Remove cross-team connection?" : "Remove domain?"}
      titleClassName="text-base justify-center"
      showCloseButton={false}
      primaryButton={{
        label: "Remove",
        callback: () => {
          onConfirm();
          closeDialog();
        },
      }}
      secondaryButton={{
        label: "Cancel",
        buttonTypeOverride: "CANCEL",
        callback: () => {
          onCancel?.();
          closeDialog();
        },
      }}
    >
      <p className="px-4 text-center text-sm text-gray-700 dark:text-invertedPrimary80">
        {isCrossTeam ? (
          <>
            Removing <u>{domainNode}</u> will discontinue cross-team data sharing with{" "}
            {formatCounterpartNames(counterparts!)}.
          </>
        ) : (
          <>
            <u>{domainNode}</u> will be removed from this company.
          </>
        )}
      </p>
    </BaseDialog>
  );
}
